import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AnnouncementForm from "./announcementComponents/AnnouncementForm";

import { useAppMeta } from "hooks";
import {
  useGetAnnouncementDetailQuery,
  useUpdateAnnouncementMutation,
} from "store/services/announcementApi";

const AnnouncementEditScreen = () => {
  let { id } = useParams();

  let navigate = useNavigate();

  const breadcrumbs = [
    {
      title: "Announcements",
      path: "/app/crm/announcement/list",
    },
    {
      title: "Edit Announcement",
    },
  ];

  // RTK Query
  const { data: announcementDetail, isLoading: loadingAnnouncementDetail } =
    useGetAnnouncementDetailQuery(id);

  const [updateAnnouncement, { isLoading: updatingAnnouncement }] = useUpdateAnnouncementMutation();

  // method
  const handleAnnouncementUpdate = (data) => {
    updateAnnouncement({ ...data, _id: id })
      .unwrap()
      .then(() => {
        navigate(-1);
        toast.success("Announcement successfully updated!");
      })
      .catch((error) => toast.error("Announcement update failed! " + error.data?.message));
  };

  useAppMeta("Edit Announcement");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingAnnouncementDetail || updatingAnnouncement}
    >
      <BreadcrumbLayout.Paper>
        <AnnouncementForm
          announcementDetail={announcementDetail}
          isBusy={loadingAnnouncementDetail || updatingAnnouncement}
          onSubmit={handleAnnouncementUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default AnnouncementEditScreen;
